<template>
  <div class="scanCode" v-if="visible">
    <div class="container">
      <div class="qrcode">
        <div id="reader"></div>
      </div>
    </div>

    <div class="btn">
      <div class="left-back" @click="close">
        <van-icon name="arrow-left" />
      </div>

      <div class="right-file">
        <van-uploader
            v-model="fileList"
            :preview-image="false"
            :after-read="dealSelectFiles"
        >
          <van-icon name="photo-o" />
        </van-uploader>
      </div>
    </div>
  </div>
</template>

<script>
import { Html5Qrcode } from "html5-qrcode";
import {Toast} from "vant-green";

export default {
  name: "ScanCode",

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      html5QrCode: null,
      fileList: []
    };
  },

  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.initCamera();
        });
      } else {
        this.stop();
      }
    }
  },

  methods: {
    initCamera() {
      Html5Qrcode.getCameras()
          .then(devices => {
            if (devices && devices.length) {
              this.html5QrCode = new Html5Qrcode("reader");
              this.start();
            }
          })
          .catch(() => {
            Toast.fail("摄像头无访问权限");
          });
    },

    start() {
      this.html5QrCode
          .start(
              { facingMode: "environment" },
              {
                fps: 10,
                qrbox: { width: 250, height: 250 }
              },
              decodedText => {
                this.$emit("success", decodedText);
                this.close();
              }
          )
          .catch(() => {
            Toast.fail("扫码启动失败");
          });
    },

    stop() {
      if (this.html5QrCode && this.html5QrCode.isScanning) {
        this.html5QrCode.stop();
      }
    },

    close() {
      this.stop();
      this.$emit("update:visible", false);
      this.$emit("close");
    },

    dealSelectFiles() {
      try {
        window.qrcode.callback = result => {
          this.$emit("success", result);
          this.close();
        };

        let file = this.fileList[0].file;
        let reader = new FileReader();

        reader.onload = e => {
          window.qrcode.decode(e.target.result);
        };

        reader.readAsDataURL(file);
      } catch (error) {
        Toast.fail("图片识别失败");
      }
    }
  },

  beforeDestroy() {
    this.stop();
  }
};
</script>

<style scoped>
.scanCode {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  z-index: 9999;
}

.container {
  height: 90%;
}

.qrcode {
  height: 100%;
}

.btn {
  height: 10%;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  color: #fff;
  font-size: 28px;
}
</style>